module.exports = __webpack_public_path__ + "static/media/streaming-white-circle.e3e8b1a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/streaming-white-circle.svg
// module id = 446
// module chunks = 0